(() => {
  if (customElements.get('kingpin-collection-scroll')) return;
  class CollectionScroll extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('#CollectionSection')?.querySelector('.kp-catalog-grid');
      this.section = this.closest('#CollectionSection');
      this.status = this.querySelector('.kp-scroll-status');
      this.link = this.querySelector('.kp-scroll-more');
      if (!this.grid || !('IntersectionObserver' in window)) return;
      this.controller = new AbortController();
      this.failed = false;
      this.busy = false;
      this.classList.add('kp-scroll-ready');
      this.updateStatus();
      this.link?.addEventListener('click', (event) => {
        if (this.failed) return;
        event.preventDefault();
        this.loadMore();
      }, { signal: this.controller.signal });
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) this.loadMore();
      }, { rootMargin: '600px 0px' });
      if (this.dataset.next) this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    updateStatus() {
      const loaded = this.grid.querySelectorAll(':scope > .grid-product').length;
      const total = Number(this.dataset.total);
      const template = loaded >= total ? this.dataset.complete : this.dataset.progress;
      this.status.textContent = template.replace('__LOADED__', loaded).replace('__TOTAL__', total);
    }
    async loadMore() {
      if (this.busy || this.failed || !this.dataset.next || !this.isConnected) return;
      this.busy = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.link?.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(this.dataset.next, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid collection URL');
        url.searchParams.set('view', 'ajax');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.querySelector('#CollectionSection .kp-catalog-grid');
        const nextControl = page.querySelector('kingpin-collection-scroll');
        if (!nextGrid || !nextControl) throw new Error('Invalid collection response');
        const existing = new Set([...this.grid.querySelectorAll('.grid-product__link')].map(link => link.getAttribute('href')));
        const cards = [...nextGrid.querySelectorAll(':scope > .grid-product')].filter(card => !existing.has(card.querySelector('.grid-product__link')?.getAttribute('href')));
        if (!cards.length) throw new Error('No new products');
        if (!this.isConnected) return;
        this.grid.append(...cards);
        page.querySelectorAll('#CollectionSection .modal--quick-shop').forEach(modal => {
          if (modal.id && !document.getElementById(modal.id)) this.section.append(modal);
        });
        this.querySelector('.kp-scroll-fallback').replaceChildren(...nextControl.querySelector('.kp-scroll-fallback').childNodes);
        this.dataset.next = nextControl.dataset.next || '';
        if (this.link) {
          this.link.hidden = !this.dataset.next;
          if (this.dataset.next) this.link.href = this.dataset.next;
        }
        if (window.theme?.reinitProductGridItem) {
          window.theme.reinitProductGridItem(window.theme.jQuery(this.section));
        }
        this.updateStatus();
        if (!this.dataset.next) this.observer.disconnect();
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected) return;
        this.failed = true;
        this.observer.disconnect();
        this.classList.remove('kp-scroll-ready');
        this.status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        this.grid.removeAttribute('aria-busy');
        this.link?.removeAttribute('aria-disabled');
      }
    }
  }
  customElements.define('kingpin-collection-scroll', CollectionScroll);
})();
